import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-74ae1487"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "topnav"
};
const _hoisted_2 = {
  key: 0,
  class: "leftbtn"
};
const _hoisted_3 = {
  key: 1,
  class: "leftbtn"
};
const _hoisted_4 = {
  key: 2,
  class: "logo"
};
const _hoisted_5 = {
  class: "rightdiv"
};
const _hoisted_6 = {
  class: "search"
};
const _hoisted_7 = {
  class: "user"
};
const _hoisted_8 = {
  class: "leftSidebar"
};
const _hoisted_9 = {
  class: "logo"
};
const _hoisted_10 = {
  class: "sbutit"
};
const _hoisted_11 = {
  class: "topNav"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icontit"
}, "NEW", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icontit"
}, "HOT", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icontit"
}, "TOP", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_16 = {
  class: "navlist"
};
const _hoisted_17 = ["name"];
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  class: "domain-tip"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_22 = {
  class: "icon-btn"
};
const _hoisted_23 = {
  key: 0,
  class: "rightSidebar"
};
const _hoisted_24 = {
  class: "logo"
};
const _hoisted_25 = {
  class: "sbutit"
};
const _hoisted_26 = {
  key: 0
};
const _hoisted_27 = {
  key: 1,
  class: "middle"
};
const _hoisted_28 = {
  class: "userinfo"
};
const _hoisted_29 = {
  class: "topNav"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_31 = {
  class: "navlist"
};
import api from '@/api/shipin2/index.js';
import { onMounted, ref, toRefs } from 'vue';
import { useIndexStore } from '../store';
import { storeToRefs } from 'pinia';
import { useRouter, useRoute } from 'vue-router';
import { goToTheRandomAddress, downloadApp, getDomian } from '@/utils';
import useClipboard from 'vue-clipboard3';
import { showDialog, Overlay } from 'vant';
import route from '../route';
export default {
  __name: 'CommonHeaderNewTopNav',
  props: {
    showTopLeftBtnIcon: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    const userIndex = useIndexStore();
    const {
      showTopLeftBtnIcon
    } = toRefs(props);

    // 使用插件
    const {
      toClipboard
    } = useClipboard();
    const copy = async msg => {
      try {
        // 复制
        await toClipboard(msg);
        showDialog({
          message: '已复制到剪贴板'
        });
        // 复制成功
      } catch (e) {
        // 复制失败
      }
    };
    const {
      UserLoginInfoStorage
    } = storeToRefs(userIndex);
    const goPushVideoList = (title, type) => {
      showSidebar.value = false;
      router.push({
        path: '/videolist',
        query: {
          title: title,
          onlytTopic: 0,
          type: type,
          id: 0
        }
      });
    };
    const onLoginOut = () => {
      UserLoginInfoStorage.value.token = '';
    };
    const golink = url => {
      showSidebar.value = false;
      window.location.href = url;
      // console.log('url', url)
      // router.replace({
      //     path: url
      // })
    };

    const goReplace = url => {
      showRightSidebar.value = false;
      router.replace({
        path: url
      });
    };
    const showSidebar = ref(false);
    const showRightSidebar = ref(false);
    const toggleSidebar = () => {
      showSidebar.value = !showSidebar.value;
    };
    const backHome = () => {
      router.replace({
        path: '/home'
      });
    };
    const locationHome = () => {
      // window.location.href = getDomian();
      if (config.value.website) {
        if (config.value.website.indexOf('http') == -1) {
          window.location.href = 'https://' + config.value.website;
        } else {
          window.location.href = config.value.website;
        }
      } else {
        router.replace({
          path: '/home'
        });
      }
    };
    const getUrl = () => {
      let url = window.location.host;
      return url;
    };
    const installApp = () => {
      const iosArr = config.value.ios_download_urls.split(',');
      const androidArr = config.value.android_download_urls.split(',');
      downloadApp(iosArr, androidArr);
    };

    // 判断当前是安卓还是IOS，取渠道后台配置的 下载地址
    const clickDownApp = () => {
      let android_download_urls = [...config.value.android_download_urls.split(',')];
      let ios_download_urls = [...config.value.ios_download_urls.split(',')];
      console.log('android_download_urls', android_download_urls, 'ios_download_urls', ios_download_urls);
      downloadApp(android_download_urls, ios_download_urls);
    };

    //视频分类数据
    const {
      categoryList
    } = storeToRefs(userIndex);
    const {
      config
    } = storeToRefs(userIndex);
    // console.log('config', config.value)

    const oldScrollTop = ref(0);
    const isHide = ref(false);
    const scrollTop = ref(0);
    const scrolling = event => {
      scrollTop.value = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

      // 设置上边界 未超过显示
      if (scrollTop.value < 87) {
        return isHide.value = false;
      }

      // 设置下边界 滑动到下边界后隐藏顶部
      if (scrollTop.value + document.documentElement.clientHeight >= document.body.scrollHeight - 100) {
        return isHide.value = true;
      }

      // 滚动条滚动的距离
      let scrollStep = scrollTop.value - oldScrollTop.value;

      // 更新——滚动前，滚动条距文档顶部的距离
      oldScrollTop.value = scrollTop.value;
      if (scrollTop.value + document.documentElement.clientHeight === document.body.scrollHeight) {
        return isHide.value = false;
      }
      if (scrollStep < 0) {
        isHide.value = false;
      } else {
        isHide.value = true;
      }
    };
    const gotoTelegram = () => {
      let telegram = config.value.telegram;
      //去除字符串@
      telegram = telegram.replace('@', '');
      window.open('https://t.me/' + telegram);
    };
    const gotoFacebook = () => {
      window.open('https://x.com/heiliaowan');
    };
    window.addEventListener('scroll', scrolling);
    onMounted(() => {
      isHide.value = false;
    });
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_overlay = _resolveComponent("van-overlay");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_unref(showTopLeftBtnIcon) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_icon, {
        name: "bars",
        onClick: _cache[0] || (_cache[0] = $event => showSidebar.value = !showSidebar.value)
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_van_icon, {
        name: "arrow-left",
        onClick: _cache[1] || (_cache[1] = $event => _unref(router).back())
      })])), _unref(config) && _unref(config).h5_logo != '' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_van_image, {
        class: "img",
        fit: "cover",
        "loading-icon": "",
        src: _unref(config).h5_logo,
        onClick: locationHome
      }, null, 8, ["src"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_van_icon, {
        onClick: _cache[2] || (_cache[2] = $event => _unref(router).push('/search')),
        name: "search"
      })]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_icon, {
        onClick: _cache[3] || (_cache[3] = $event => showRightSidebar.value = !showRightSidebar.value),
        name: "user-circle-o"
      })])])]), _createVNode(_component_van_overlay, {
        show: showSidebar.value
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_van_icon, {
          class: "right-close",
          name: "cross",
          onClick: _cache[4] || (_cache[4] = $event => toggleSidebar())
        }), _createElementVNode("div", _hoisted_9, [_unref(config).h5_logo ? (_openBlock(), _createBlock(_component_van_image, {
          key: 0,
          class: "img",
          "loading-icon": "",
          fit: "cover",
          "lazy-load": "",
          src: _unref(config).h5_logo,
          onClick: backHome
        }, null, 8, ["src"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, "永久网址：" + _toDisplayString(_unref(config).website), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
          class: "tit",
          onClick: _cache[5] || (_cache[5] = $event => goPushVideoList('最新爆料', 'last'))
        }, [_hoisted_12, _createTextVNode(" 最新爆料 ")]), _createElementVNode("div", {
          class: "tit",
          onClick: _cache[6] || (_cache[6] = $event => goPushVideoList('热门爆料', 'hot'))
        }, [_hoisted_13, _createTextVNode(" 热门爆料 ")]), _createElementVNode("div", {
          class: "tit",
          onClick: _cache[7] || (_cache[7] = $event => goPushVideoList('最多观看', 'max'))
        }, [_hoisted_14, _createTextVNode(" 最多观看 ")])]), _hoisted_15, _createElementVNode("div", _hoisted_16, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categoryList).slice(0, 5), (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            name: index,
            key: index
          }, [_createVNode(_component_van_icon, {
            name: "fire-o"
          }), _createElementVNode("a", {
            href: "javascript:void(0);",
            onClick: $event => golink(`/home?title=${item.title}&onlytTopic=0&type=label&id=${item.id}`)
          }, _toDisplayString(item.title), 9, _hoisted_18)], 8, _hoisted_17);
        }), 128))])]), _createElementVNode("div", _hoisted_19, [_createTextVNode(" 发送邮件任意内容到："), _hoisted_20, _createElementVNode("span", null, _toDisplayString(_unref(config).email), 1), _hoisted_21, _createTextVNode(" 获取最新域名链接 ")]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_van_image, {
          src: require('../assets/icon-t.png'),
          fit: "cover",
          onClick: gotoTelegram
        }, null, 8, ["src"]), _createVNode(_component_van_image, {
          src: require('../assets/icon-f.png'),
          fit: "cover",
          onClick: gotoFacebook
        }, null, 8, ["src"])]), _createElementVNode("div", {
          class: "downApp",
          onClick: clickDownApp
        }, "下载手机客户端")])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_overlay, {
        show: showRightSidebar.value
      }, {
        default: _withCtx(() => [showRightSidebar.value ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_van_icon, {
          class: "right-close",
          name: "cross",
          onClick: _cache[8] || (_cache[8] = $event => showRightSidebar.value = !showRightSidebar.value)
        }), _createElementVNode("div", _hoisted_24, [_unref(config).h5_logo ? (_openBlock(), _createBlock(_component_van_image, {
          key: 0,
          class: "img",
          "loading-icon": "",
          fit: "cover",
          "lazy-load": "",
          src: _unref(config).h5_logo,
          onClick: backHome
        }, null, 8, ["src"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_25, [_unref(UserLoginInfoStorage).token == '' ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createVNode(_component_van_icon, {
          name: "contact",
          class: "icon"
        }), _createElementVNode("span", {
          onClick: _cache[9] || (_cache[9] = $event => _unref(router).push({
            name: 'register',
            query: {
              onpage: 'login'
            }
          }))
        }, "登录"), _createTextVNode(" 或 "), _createElementVNode("span", {
          onClick: _cache[10] || (_cache[10] = $event => _unref(router).push({
            name: 'register',
            query: {
              onpage: 'register'
            }
          }))
        }, "注册")])) : (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createTextVNode(" 用户名：" + _toDisplayString(_unref(UserLoginInfoStorage).username) + " ", 1), _createElementVNode("div", {
          class: "sign",
          onClick: _cache[11] || (_cache[11] = $event => _unref(route).push('/signin'))
        }, "签到")])]))]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", {
          class: "tougao",
          onClick: _cache[12] || (_cache[12] = $event => goReplace('/baoliao'))
        }, " 爆料 "), _createElementVNode("div", {
          class: "baoguang",
          onClick: _cache[13] || (_cache[13] = $event => goReplace('/qiugua'))
        }, " 求瓜 ")]), _hoisted_30, _createElementVNode("div", _hoisted_31, [_createElementVNode("ul", null, [_createElementVNode("li", {
          onClick: _cache[14] || (_cache[14] = $event => copy(_unref(config).logo_title))
        }, " 站点名称：" + _toDisplayString(_unref(config).logo_title), 1), _createElementVNode("li", {
          onClick: _cache[15] || (_cache[15] = $event => copy(_unref(config).website))
        }, " 官网地址：" + _toDisplayString(_unref(config).website), 1), _createElementVNode("li", {
          onClick: _cache[16] || (_cache[16] = $event => copy(_unref(getDomian)()))
        }, " 分享连接：" + _toDisplayString(_unref(getDomian)()), 1)])]), _withDirectives(_createElementVNode("button", {
          class: "downApp",
          onClick: _cache[17] || (_cache[17] = $event => onLoginOut())
        }, " 退出登录 ", 512), [[_vShow, _unref(UserLoginInfoStorage).token != '']])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["show"])]);
    };
  }
};